import location from './location.svg';
import email from './email.svg';
import phone from './phone.svg';

export default {
  location,
  email,
  phone,
};



// WEBPACK FOOTER //
// ./src/img/contact/index.js